import { useState, useCallback } from 'react';
import { Product } from '../types/Product';
import { useProducts } from '../context/ProductContext';
import { generateMenuSuggestion } from '../utils/menuGenerator';
import { MenuSuggestion } from '../types/Menu';

export interface VirtualKitchenState {
  selectedIngredients: Product[];
  activeShelf: string | null;
  currentRecipe: MenuSuggestion | null;
}

export const useVirtualKitchen = () => {
  const { products } = useProducts();
  const [state, setState] = useState<VirtualKitchenState>({
    selectedIngredients: [],
    activeShelf: null,
    currentRecipe: null,
  });

  const generateRandomRecipe = useCallback((
    maxPricePerDish: number, 
    courseCount: number = 1
  ): MenuSuggestion => {
    const recipe = generateMenuSuggestion(products, maxPricePerDish, courseCount, 'balanced');
    setState(prev => ({
      ...prev,
      currentRecipe: recipe
    }));
    return recipe;
  }, [products]);

  const generateBasicRecipe = useCallback((
    maxPricePerDish: number, 
    courseCount: number = 1
  ): MenuSuggestion => {
    const recipe = generateMenuSuggestion(products, maxPricePerDish, courseCount, 'economic');
    setState(prev => ({
      ...prev,
      currentRecipe: recipe
    }));
    return recipe;
  }, [products]);

  return {
    ...state,
    generateRandomRecipe,
    generateBasicRecipe
  };
};